// src/components/Admin/Login.jsx
import React, { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { signInWithEmailAndPassword } from 'firebase/auth';
import { FiLock, FiMail, FiArrowRight, FiShield } from 'react-icons/fi';
import './Login.css';
import { auth } from '../firebase/firebase-config';

function Login() {
  const [email, setEmail] = useState('');
  const [password, setPassword] = useState('');
  const [error, setError] = useState('');
  const [loading, setLoading] = useState(false);
  const navigate = useNavigate();

  const handleLogin = async (e) => {
    e.preventDefault();
    setError('');
    setLoading(true);

    try {
      // Firebase Email & Password ile giriş yapma fonksiyonu
      await signInWithEmailAndPassword(auth, email, password);
      // Başarılı giriş sonrası panere yönlendiriyoruz
      navigate('/admin/dashboard');
    } catch (err) {
      console.error("Giriş hatası:", err.code);
      setError('E-posta veya şifre hatalı. Lütfen bilgilerinizi kontrol edin.');
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="admin-login-wrapper">
      <div className="login-card">
        
        <div className="login-header">
          <div className="admin-logo-icon"><FiShield /></div>
          <h2>Yönetici <span className="gold-text">Girişi</span></h2>
          <p>Av. Emre Uygun Hukuk ve Danışmanlık Paneli</p>
        </div>

        {error && <div className="error-alert">{error}</div>}

        <form onSubmit={handleLogin} className="login-form">
          <div className="input-group">
            <span className="input-icon"><FiMail /></span>
            <input 
              type="email" 
              placeholder="Yönetici E-Posta Adresi" 
              value={email}
              onChange={(e) => setEmail(e.target.value)}
              required 
            />
          </div>

          <div className="input-group">
            <span className="input-icon"><FiLock /></span>
            <input 
              type="password" 
              placeholder="Şifreniz" 
              value={password}
              onChange={(e) => setPassword(e.target.value)}
              required 
            />
          </div>

          <button type="submit" className="login-btn" disabled={loading}>
            {loading ? 'Giriş Yapılıyor...' : <><span>Panele Git</span> <FiArrowRight /></>}
          </button>
        </form>

        <div className="login-footer">
          <a href="/" className="back-home-link">&larr; Ana Sayfaya Dön</a>
        </div>

      </div>
    </div>
  );
}

export default Login;